import {field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";

export class TableLayoutData extends LocalisableEntityData<TableLayoutData> {
    @identifier id: number;
    @field name: string;
}
